import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private readonly storageKey = 'authtoken';
    private token: string;

    constructor(private http: HttpClient) {
    }

    login(loginData: any): Observable<boolean> {
        return this.http.post(`/api/auth`, loginData).pipe(
            map((resp: any) => {
                this.saveToken(resp.access_token);
                return true;
            }),
            catchError((err: any) => of(false))
        );
    }

    private saveToken(token: string): void {
        localStorage.setItem(this.storageKey, token);
        this.token = token;
    }

    getToken() {
        if (!this.token) {
            const fromStorage = localStorage.getItem(this.storageKey);
            if (fromStorage) {
                this.token = fromStorage;
            }
        }

        return this.token || '';
    }

    logout(): Observable<void> {
        this.token = null;
        localStorage.removeItem(this.storageKey);
        return of(null);
    }
}
